import { isEdelvives } from 'app/utils/utils';
import EdelvivesAIChatbot from './EdelvivesAIChatbot';
import TangerineAIChatbot from './TangerineAIChatbot';
console.log("process.env.CLIENT en indexjschatbot", process.env.CLIENT);

// Export the appropriate chatbot component based on the client
const AIChatbot = isEdelvives() ? EdelvivesAIChatbot : TangerineAIChatbot;

export default AIChatbot;
